import { render, staticRenderFns } from "./NavigateToOverviewButton.vue?vue&type=template&id=d7e8ea2a&"
import script from "./NavigateToOverviewButton.vue?vue&type=script&lang=js&"
export * from "./NavigateToOverviewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7e8ea2a')) {
      api.createRecord('d7e8ea2a', component.options)
    } else {
      api.reload('d7e8ea2a', component.options)
    }
    module.hot.accept("./NavigateToOverviewButton.vue?vue&type=template&id=d7e8ea2a&", function () {
      api.rerender('d7e8ea2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/NavigateToOverviewButton.vue"
export default component.exports